import {CreateReducer} from '../utils/create_reducer';
import {
    CLEAR_DATA,
    GET_ESTIMATE_DETAIL,
    GET_INVOICE_DETAIL,
    GET_INVOICE_ESTIMATES_LIST,
    GET_INVOICE_LIST
} from "../actions/account_invoice_action";

const initState = {
    invoices: [],
    estimates: [],
    isFetching: true,
    invoiceDetail: undefined,
    estimateDetail: undefined
};

const accountInvoiceReducer = CreateReducer(initState, {
    [GET_INVOICE_LIST](state, action) {
        return {...state, invoices: action.payload, isFetching: false}
    },
    [GET_INVOICE_ESTIMATES_LIST](state, action) {
        return {...state, estimates: action.payload, isFetching: false}
    },
    [GET_INVOICE_DETAIL](state, action) {
        return {...state, invoiceDetail: action.payload, isFetching: false}
    },
    [GET_ESTIMATE_DETAIL](state, action) {
        return {...state, estimateDetail: action.payload, isFetching: false}
    },
    [CLEAR_DATA](state, action) {
        return {...initState}
    }
});

export default accountInvoiceReducer;


// WEBPACK FOOTER //
// ./src/reducers/account_invoice_reducer.js